// var splide = new Splide( '#giveaway-slides', {
//   type    : 'loop',
//   perPage : 3,
//   autoplay: true,
//   gap: 10,
//   breakpoints: {
// 		767: {
// 			perPage: 1,
// 			gap: 5,
// 			padding: '10%',
// 		},
//   }
// } );

// splide.mount();

var news_Splide = new Splide( '#news-carousel', {
  perPage : 3,
  gap: 10,
  breakpoints: {
    767: {
      perPage: 1,
      gap: 5,
      padding: { left: '15px', right: '30px' }, // ensures first slide is flush left
      focus: 'center', // centers slides as you scroll
    },
  }
} );

news_Splide.mount();